/** One group, so the browser keeps the radios across every application card to a single choice. */
export const DEFAULT_ROLE_RADIO_GROUP = 'default-role';

export const MY_ACCESS_DESCRIPTION =
  "Your default role is used when you sign in and the app you chose doesn't settle which role you act in. Changing it doesn't affect a session you already have.";

/** Below Tailwind's `sm`, where a top-right toast would sit over the top bar. */
export const PHONE_MEDIA_QUERY = '(max-width: 639px)';
